import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import EventBanner from './components/EventBanner';
import ServiceCategories from './components/ServiceCategories';
import FeaturedShops from './components/FeaturedShops';
import BookingProcess from './components/BookingProcess';
import InstagramPortfolio from './components/InstagramPortfolio';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar isFixed={true} />
      <HeroSection />
      <EventBanner />
      <ServiceCategories />
      <FeaturedShops />
      <BookingProcess />
      <InstagramPortfolio />
      <Footer />
    </div>
  );
}
